import { qualityMessage, staleSourceMessage } from "../../utils/directorFormat";

const PROVENANCE_KEYS = new Set([
  "qualityFlags",
  "sourceIssueCodes",
  "quality_flags",
  "source_issue_codes",
]);

const asFlags = (value) => (
  (Array.isArray(value) ? value : [value])
    .filter((flag) => typeof flag === "string" && flag)
);

// `qualityDetails` ([{ code, projects }]) diz em quais obras cada aviso aparece.
const collectDetails = (value, details) => {
  if (!Array.isArray(value)) return;
  value
    .filter((item) => typeof item?.code === "string" && Array.isArray(item.projects))
    .forEach((item) => {
      if (!details.has(item.code)) details.set(item.code, new Set());
      item.projects.filter((name) => typeof name === "string" && name)
        .forEach((name) => details.get(item.code).add(name));
    });
};

const collectSourceFlags = (sources = [], details = new Map(), freshness = []) => {
  const collected = [];
  const visited = new WeakSet();
  const visit = (value) => {
    if (typeof value === "string") return;
    if (!value || typeof value !== "object" || visited.has(value)) return;
    visited.add(value);
    if (Array.isArray(value)) {
      value.forEach(visit);
      return;
    }
    if (
      Object.prototype.hasOwnProperty.call(value, "data")
      && Object.prototype.hasOwnProperty.call(value, "dataSignature")
      && Object.prototype.hasOwnProperty.call(value, "requestSignature")
    ) {
      if (
        typeof value.dataSignature !== "string"
        || value.dataSignature !== value.requestSignature
      ) return;
      visit(value.data);
      return;
    }
    Object.entries(value).forEach(([key, item]) => {
      if (key === "dataProvenance") {
        // Diretoria 2.0: a marca demo chega como `dataProvenance.classification`.
        if (item?.classification === "demo_mock_data") collected.push("demo_mock_data");
      }
      if (key === "freshness" && Array.isArray(item)) {
        item.filter((entry) => typeof entry?.sourceType === "string" && entry.status).forEach((entry) => freshness.push(entry));
      }
      if (key === "qualityDetails") {
        collectDetails(item, details);
      } else if (PROVENANCE_KEYS.has(key)) {
        collected.push(...asFlags(item));
      } else {
        visit(item);
      }
    });
  };
  (Array.isArray(sources) ? sources : [sources]).forEach(visit);
  return collected;
};

const QualityBanner = ({
  flags = [],
  sourceIssueCodes = [],
  sources = [],
  status = "available",
}) => {
  const details = new Map();
  const freshness = [];
  const uniqueFlags = [...new Set([
    ...asFlags(flags),
    ...asFlags(sourceIssueCodes),
    ...collectSourceFlags(sources, details, freshness),
  ])].sort();
  const demo = uniqueFlags.includes("demo_mock_data");
  const qualityFlags = uniqueFlags.filter((flag) => flag !== "demo_mock_data");
  if (status === "available" && uniqueFlags.length === 0) return null;
  // Uma linha por frase: códigos desconhecidos caem todos na mesma frase genérica.
  const lines = new Map();
  const addLine = (message, flag) => {
    if (!lines.has(message)) lines.set(message, new Set());
    (details.get(flag) ?? []).forEach((name) => lines.get(message).add(name));
  };
  qualityFlags.forEach((flag) => {
    // Atraso: nomeia a fonte e a data da última leitura; o texto genérico é a reserva.
    const named = flag === "critical_stale" || flag === "stale"
      ? freshness.filter((item) => item.status === flag).map(staleSourceMessage).filter(Boolean)
      : [];
    if (named.length) named.forEach((message) => addLine(message, flag));
    else addLine(qualityMessage(flag), flag);
  });
  return <aside
    className={`director-quality${demo ? " director-quality--demo" : ""}`}
    aria-label={demo ? "Dados demonstrativos simulados" : "Qualidade dos dados"}
    role="status"
  >
    <strong>{demo
      ? "Dados demonstrativos simulados — não representam operação financeira real."
      : "Atenção à qualidade da leitura"}</strong>
    {lines.size > 0
      ? <ul>{[...lines.entries()].map(([message, names]) => <li key={message}>
        {message}
        {names.size > 0 && <em className="director-quality__where"> Onde: {[...names].sort().join(", ")}.</em>}
      </li>)}</ul>
      : (!demo ? <p>A leitura possui restrições de qualidade.</p> : null)}
  </aside>;
};

export default QualityBanner;
